import { message } from 'antd';
import Axios, {
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import { resData } from './interface';

// 统一配置
const baseURL = import.meta.env.VITE_BASE_URL;
export const service = Axios.create({
  baseURL,
  responseType: 'json',
  timeout: 30000,
});

// 请求拦截
service.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 拦截响应
service.interceptors.response.use(
  async (response: AxiosResponse) => {
    const res = response.data;
    // Blob 下载接口可能以 HTTP 200 返回 JSON 格式的业务错误
    if (response.config.responseType === 'blob') {
      const responseContentType = response.headers['content-type'] || '';
      const blobContentType =
        response.data instanceof Blob ? response.data.type : '';
      const isJsonResponse = `${responseContentType} ${blobContentType}`
        .toLowerCase()
        .includes('application/json');

      if (isJsonResponse) {
        try {
          const blobResponse =
            response.data instanceof Blob
              ? JSON.parse(await response.data.text())
              : response.data;

          if (blobResponse.code !== 200) {
            if (blobResponse.message) {
              message.error(blobResponse.message, 3);
            }
            return Promise.reject({
              ...blobResponse,
              url: response.config.url,
            });
          }
        } catch (error) {
          const errorMessage = 'Failed to parse server response';
          message.error(errorMessage, 3);
          return Promise.reject({
            message: errorMessage,
            error,
            url: response.config.url,
          });
        }
      }

      return response;
    }
    // 如果有新的token，更新token
    if (response.headers['accesstoken'] !== undefined) {
      const newToken = response.headers['accesstoken'];
      localStorage.setItem('token', newToken);
    }
    // 这块需要修改 根据请求返回成功标志
    if (res.code === 200) {
      return response.data;
    } else {
      if (res.message) {
        message.error(res.message, 3);
      }
      return Promise.reject({ ...res, url: response.config.url });
    }
  },
  (err) => {
    if (err.response && err.response.status === 401) {
      message.error('Unauthorized', 2).then(() => {
        window.location.href = '/login';
      });
    } else {
      message.error(err.message, 3);
    }
    return Promise.reject(err);
  }
);

// 设置返回值和请求值范型
export default function request<Res = any, Q = any>(
  req: AxiosRequestConfig & {
    data?: Q;
  }
) {
  return service(req).then(
    (res) => {
      return res as unknown as resData<Res>;
    },
    (res) => {
      return Promise.reject((res.data || res) as resData<Res>);
    }
  );
}
